import "@cyntler/react-doc-viewer/dist/index.css";
import { Modal } from "@mui/material";
import React, { useState, useRef } from "react";
import {
  bookIcon,
  closeIco,
  folderIco,
  folderOpenIco,
} from "../../../Assets/icons/gisIcons/icons";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "1200px",
  height: "90vh",

  boxShadow: "0px 4px 4px 3px rgba(0, 0, 0, 0.25)",
  boxSizing: "border-box",
  background: "#FFFFFF",
  border: "1px solid rgba(58, 58, 60, 0.5)",
  borderRadius: "16px",
};
/**This Doc viewer is folder based*/
const DocViwerModal = ({ isOpen, onClose }) => {
  const files = {
    documents: [
      {
        folder_name: "Drone Data Processing Reports",
        documents: [
          {
            title: "18-19 AUG UAV",
            url: "https://d2boh9caghjgas.cloudfront.net/aic/DRONE_DATA_PROCESSING_REPORTS/AIC_18-19_AUGUST_UAV_REPORT.pdf",
          },
          {
            title: "22-27 AUG UAV",
            url: "https://d2boh9caghjgas.cloudfront.net/aic/DRONE_DATA_PROCESSING_REPORTS/AIC_22-27AUG_UAV_REPORT.pdf",
          },
          {
            title: "30-31 AUG UAV",
            url: "https://d2boh9caghjgas.cloudfront.net/aic/DRONE_DATA_PROCESSING_REPORTS/AIC_30-31_AUGUST_UAV_REPORT.pdf",
          },
          {
            title: "2-3 SEP UAV",
            url: "https://d2boh9caghjgas.cloudfront.net/aic/DRONE_DATA_PROCESSING_REPORTS/AIC_2-3SEP_UAV_REPORT.pdf",
          },
          {
            title: "28-29 SEP UAV",
            url: "https://d2boh9caghjgas.cloudfront.net/aic/DRONE_DATA_PROCESSING_REPORTS/AIC_28-29SEP_UAV_REPORT.pdf",
          },
        ],
      },
      {
        folder_name: "DGNSS Reports",
        documents: [
          {
            title: "03-08-2024 GCP Baseline Processing Report",
            url: "https://d2boh9caghjgas.cloudfront.net/aic/DGNSS_REPORT/03-08-2024_GCP_Baseline%20Processing%20Report.pdf",
          },
          {
            title: "06-08-2024 GCP Baseline Processing Report",
            url: "https://d2boh9caghjgas.cloudfront.net/aic/DGNSS_REPORT/06-08-2024_GCP_Baseline%20Processing%20Report.pdf",
          },
          {
            title: "20-08-2024 GCP Baseline Processing Report",
            url: "https://d2boh9caghjgas.cloudfront.net/aic/DGNSS_REPORT/20-08-2024_GCP_Baseline%20Processing%20Report.pdf",
          },
          {
            title: "29-08-2024 GCP Baseline Processing Report",
            url: "https://d2boh9caghjgas.cloudfront.net/aic/DGNSS_REPORT/29-08-2024_GCP_Baseline%20Processing%20Report.pdf",
          },
          {
            title: "30-08-2024 GCP Baseline Processing Report",
            url: "https://d2boh9caghjgas.cloudfront.net/aic/DGNSS_REPORT/30-08-2024_GCP_Baseline%20Processing%20Report.pdf",
          },
          {
            title: "01-09-2024 GCP Baseline Processing Report",
            url: "https://d2boh9caghjgas.cloudfront.net/aic/DGNSS_REPORT/01-09-2024_GCP_Baseline%20Processing%20Report.pdf",
          },
          {
            title: "CORS TO BASE Baseline Processing Report",
            url: "https://d2boh9caghjgas.cloudfront.net/aic/DGNSS_REPORT/CORS%20TO%20BASE_Baseline%20Processing%20Report.pdf",
          },
        ],
      },
      {
        folder_name: "Project Reports",
        documents: [
          {
            title: "Survey Report",
            url: "https://d2boh9caghjgas.cloudfront.net/aic/PROJECT_REPORT/AIC_SURVEY_REPORT.pdf",
          },
        ],
      },
    ],
  };

  const [pdfUrl, setPdfUrl] = useState(null);
  const [scale, setScale] = useState(1);

  const handleOpenPdf = (url, title) => {
    setPdfUrl({ uri: url, fileType: "pdf", title: title });
    setScale(1); // Reset scale when opening a new PDF
  };

  const pdfObjectRef = useRef(null);

  const [openFolders, setOpenFolders] = useState({});

  const toggleFolder = (folderIndex) => {
    setOpenFolders((prev) => ({
      [folderIndex]: !prev[folderIndex], // Toggle the folder open/closed state
    }));
  };

  return (
    <Modal
      open={isOpen}
      onClose={() => {
        onClose();
      }}
      BackdropProps={{
        style: {
          backgroundColor: "rgba(0, 0, 0, 0.3)", // Adjust the opacity as needed
        },
      }}
    >
      <div style={style} className="flex w-full flex-col px-12 pb-12 pt-8">
        <div className="flex h-[10%] w-full flex-row justify-between">
          <p className="text-2xl font-semibold tracking-widest">
            Inspect Document Viewer
          </p>
          <button
            id="closeButton"
            onClick={onClose}
            className="absolute right-4 top-4 flex h-8 w-8 items-center justify-center overflow-hidden rounded-full transition duration-300 ease-in-out hover:bg-gray-300"
          >
            <div className="flex h-6 w-6 justify-center rounded-full bg-white">
              <img
                src={closeIco}
                alt="Close"
                className="h-6 w-6 invert-[100%] filter transition duration-300 ease-in-out"
              />
            </div>
          </button>
        </div>

        <div className="flex h-[90%] w-full flex-row">
          <div className="flex w-[30%] flex-col">
            <div className="flex flex-row">
              <img src={bookIcon} alt="bookIcon" className="mr-4 h-6 w-6" />
              <span className="font-medium tracking-wider">Documents</span>
            </div>
            {files?.documents?.map((folder, folderIndex) => (
              <div key={folderIndex} className="overflow-y-auto">
                {/* Folder Header with Chevron */}
                <div
                  className="mt-4 flex cursor-pointer items-center gap-4"
                  onClick={() => toggleFolder(folderIndex)}
                >
                  {openFolders[folderIndex] ? (
                    <img src={folderOpenIco} alt="" />
                  ) : (
                    <img src={folderIco} alt="" />
                  )}
                  <p className="tracking-normal">{folder?.folder_name}</p>
                </div>

                {/* Documents List (Visible if folder is open) */}
                {openFolders[folderIndex] && (
                  <div className="mt-4 flex flex-col overflow-y-auto">
                    {folder?.documents?.map((doc, docIndex) => (
                      <button
                        key={docIndex}
                        className={`border-l p-2 text-left transition duration-200 ease-in-out ${
                          pdfUrl && pdfUrl.uri === doc.url
                            ? "border-black font-bold"
                            : "hover:border-black hover:bg-[#D9D9D9]"
                        }`}
                        onClick={() => handleOpenPdf(doc.url, doc.title)}
                      >
                        {docIndex + 1}. {doc.title}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="relative flex h-full w-[70%] flex-grow flex-col overflow-hidden">
            {pdfUrl ? (
              <div className="relative h-full w-full overflow-x-auto overflow-y-auto">
                <iframe
                  title={pdfUrl?.title || "PDF Viewer"}
                  id="pdfIframe"
                  ref={pdfObjectRef}
                  src={`${pdfUrl?.uri}`}
                  type="application/pdf"
                  style={{ height: "100%", width: "100%", zIndex: 40 }}
                />
                <div
                  id="hideButtons"
                  className="absolute right-0 top-0 z-50 flex h-14 w-32 bg-[rgb(50,54,57)] text-white"
                  style={{ display: "block" }}
                ></div>
              </div>
            ) : (
              <div className="flex h-full items-center justify-center rounded-3xl bg-gray-200">
                Please select a document to view
              </div>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DocViwerModal;
